var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"title",on:{"click":function($event){return _vm.close()}}},[_c('i',{staticClass:"material-icons"},[_vm._v("minimize")]),_c('h4',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }